import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";
import ArticleCard from "@/components/common/ArticleCard";

export default function LatestGrid() {
  const list = articles.slice(4, 10);

  return (
    <section aria-labelledby="latest-title" className="bg-background-100 px-4 py-12 md:px-6 md:py-16">
      <div className="mb-7 flex flex-wrap items-end justify-between gap-3">
        <div>
          <p className="mb-2 flex items-center gap-2 text-xs font-medium tracking-[0.25em] text-primary-600">
            <span className="h-px w-6 bg-primary-400" />
            LATEST
          </p>
          <h2 id="latest-title" className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            最新瓜料
          </h2>
        </div>
        <Link
          to="/news"
          className="inline-flex items-center gap-1 whitespace-nowrap rounded-full border border-background-300 bg-background-50 px-4 py-2 text-sm text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600"
        >
          查看全部
          <i className="ri-arrow-right-line" aria-hidden="true" />
        </Link>
      </div>

      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {list.map((article) => (
          <ArticleCard key={article.id} article={article} />
        ))}
      </div>
    </section>
  );
}